<template>
  <PageWrapper type="forgot">
    <FormLogo slot="logo" />

    <FormPasswordRecovery slot="passwordRecovery" />

    <PageContent slot="content" />
  </PageWrapper>
</template>

<script>
import PageWrapper from '@/components/login/PageWrapper.vue'
import PageContent from '@/components/login/PageContent.vue'
import FormLogo from '@/components/login/FormLogo.vue'
import FormPasswordRecovery from '@/components/login/FormPasswordRecovery.vue'

export default {
  name: 'RecoveryPassword',
  components: {
    PageWrapper,
    PageContent,
    FormLogo,
    FormPasswordRecovery
  }
}
</script>
